define("shared/errors/media-library", ["exports", "ember-exex/error"], function (_exports, _error) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.UpgradeMediaSizeError = _exports.MediaUploadError = _exports.MediaSizeError = _exports.ImageSizeError = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-exex/error"eaimeta@70e063a35619d71f

  const MediaUploadError = (0, _error.defineError)({
    name: 'MediaLibraryError',
    message: 'Media Upload Error',
    resolve: function handleMediaUploadError(_ref) {
      let {
        message,
        title
      } = _ref;
      this.alerts.warning(message, {
        title
      });
    }
  });
  _exports.MediaUploadError = MediaUploadError;
  const ImageSizeError = (0, _error.defineError)({
    name: 'ImageSizeError',
    message: 'ImageSizeError',
    resolve: function handleImageSizeError(_ref2) {
      let {
        message,
        title = this.intl.t('alerts.media_items.new.image_limit_over.title'),
        location
      } = _ref2;
      this.alerts.upgrade(message, {
        title,
        feature: 'plans',
        location,
        upgradeText: this.intl.t('shared_phrases.view_my_plan')
      });
    },
    extends: MediaUploadError
  });
  _exports.ImageSizeError = ImageSizeError;
  const UpgradeMediaSizeError = (0, _error.defineError)({
    name: 'UpgradeMediaSizeError',
    message: 'UpgradeMediaSizeError',
    resolve: function handleMediaSizeError() {
      this.showUpgradeModal('largerVideos', 'upload video limit');
    },
    extends: MediaUploadError
  });
  _exports.UpgradeMediaSizeError = UpgradeMediaSizeError;
  const MediaSizeError = (0, _error.defineError)({
    name: 'MediaSizeError',
    message: 'MediaSizeError',
    resolve: function handleMediaSizeError(_ref3) {
      let {
        message,
        title = this.intl.t('alerts.media_items.new.image_limit_over.title')
      } = _ref3;
      this.alerts.alert(message, {
        title
      });
    },
    extends: MediaUploadError
  });
  _exports.MediaSizeError = MediaSizeError;
});